import script from "./ModalHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalHeader.vue?vue&type=script&setup=true&lang=js"

import "./ModalHeader.vue?vue&type=style&index=0&id=67d555f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d555f9"]])

export default __exports__